module.exports = __webpack_public_path__ + "static/media/icon_playground_heart_active.77c72e19.svg";